<template>
  <b-row>
        <div class="travel-bc w-100">
            <div class="container h-100">
                <div class="d-flex align-items-center justify-content-start col-md-12 h-100">
                    <div>
                        <h2 class="color-brand-4 tw-text-24px font-weight-light tw-uppercase mb-4" id="top">Selectare oferte de asigurare</h2>
                        <b-btn class="btn btn-custom border-brand-4 color-brand-4" variant="link" @click="prevStep">< Modifică datele</b-btn>
                    </div>
                </div>
            </div>
        </div>

       <div class="container">
            <b-row v-if="!fetchedProviders" class="d-flex justify-content-center">
                <b-spinner  variant="primary" label="Spinning"></b-spinner>
            </b-row>

            <b-row>
                <b-col md="9" sm="12" class="p-0 m-0">
                    <QuotationsTable v-for="(traveler, index) in travelers" :key="index" :traveler="traveler" :index="index"></QuotationsTable>
                    <h2 class="color-brand-4 py-4" id="quotations-total"><span class="tw-text-18px">TOTAL:</span> <span class="tw-text-24px">{{ totalSum }}</span> RON</h2>
                    <b-btn variant="primary" class="py-2 px-4 mb-4 btn btn-primary bg-brand-1 hover-bg-brand-4 hover:tw-text-white hover-border-brand-4 btn-custom btn-custom-lg" @click="nextStep" :disabled="!allQuotationsSelected" v-b-modal.terms-modal>Continuă</b-btn>
                </b-col>
                <b-col md="3" sm="12" class="p-0 m-0">
                    <CollectorData :collector="collector"></CollectorData>
                </b-col>
            </b-row>
        </div>
  </b-row>
</template>
<script>

import QuotationsTable from "./QuotationsTable";
import CollectorData from "./CollectorData";
import {
  FETCH_QUOTATIONS,
  INIT_QUOTATIONS, FETCH_PROVIDERS
} from "../store/travel.module";
import {mapGetters} from "vuex";
import EventBus from '../eventbus';
import moment from "moment/moment";

export default {
  name: "TravelQuotations",
  metaInfo: {
    title: 'Oferte - Asigurare calatorie online - Fabrica de Asigurari',
  },
  components: {QuotationsTable, CollectorData},
  data() {
    return {
      fetchedProviders: false,
      termsMessage: ''
    }
  },
  computed: {
    ...mapGetters(['travelers', 'providers', 'isLoggedIn', 'collector', 'quotations','amountInsured']),
    totalSum() {
      let sum = 0;
      for (let traveler of this.travelers) {
        if (traveler.selectedQuotation) {
          sum += parseInt(traveler.selectedQuotation.price);
        }
      }

      return sum;
    },
    allQuotationsSelected() {
      let ok = true;
      for (let traveler of this.travelers) {
        if(!traveler.selectedQuotation) {
          ok = false;
          break;
        }
      }

      return ok;
    },
    isMobile() {
      return window.screen.width < 575.98;
    }
  },
  mounted() {
    this.$router.push('/asigurare-de-calatorie/oferte');
    $('meta[name="description"]').attr('content','Compara ofertele de asigurare calatorie online si emite-ti asigurarea simplu, sigur si rapid.');
    if(this.isMobile) $('body').scrollTop(100);
    $('#calatori-div').html('');
    $('#calatori-div').css('display','block');
    $('#calatori-div').height($('#travel-login-loaded').height()/2);
    for (let i = 0; i < this.travelers.length; i++) {
      //fill traveler data sidebar with data from previous screen
      let travelerSidebarData = this.travelerData(i + 1,this.travelers[i]);
      $('#calatori-div').append(travelerSidebarData);

      //make sure quotation table is visible if user decides to change some data in the previous screen
      this.travelers[i].selectedQuotation = null;
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.$store.dispatch(FETCH_PROVIDERS)
          .then(() => {
            this.fetchedProviders = true;
            this.$store.commit(INIT_QUOTATIONS, this.providers);
            this.$store.dispatch(FETCH_QUOTATIONS, {travelers: this.travelers, providers: this.providers});
          })
          .catch(err => console.log(err));
    },
    travelerData(travelerIndex, traveler) {
        return '<p class="pb-0 tw-text-16px">Călător ' + travelerIndex + ':</p>' +
            '<p class="tw-text-18px color-brand-4">' +
                traveler.firstName + ' ' + traveler.lastName + ', ' + this.ageFromCNP(traveler.cnp) + ' ani' +
            '</p>' +
            '<p class="tw-text-18px pb-3 color-brand-4">' +
                'Suma asigurată: ' + this.amountInsured[traveler.amount_insured_id] +
            '</p>';
    },
    ageFromCNP(cnp) {
      let now = moment();
      if (cnp.charAt(0) === '1' || cnp.charAt(0) === '2') {
        let birthDate = moment('19' + cnp.substring(1,3) + '-' + cnp.substring(3,5) + '-' + cnp.substring(5,7));
        return now.diff(birthDate, 'years');
      } else {
        let birthDate = moment('20' + cnp.substring(1,3) + '-' + cnp.substring(3,5) + '-' + cnp.substring(5,7));
        return now.diff(birthDate, 'years');
      }
    },
    htmlToVNode(html) {
      return [
        this.$createElement('div', { domProps: { innerHTML: html } })
      ]
    },
    prevStep() {
      EventBus.$emit('prev-step')
    },
    nextStep() {
      this.termsMessage = 'Trecând mai departe, declar că am înțeles condițiile poliței de asigurare și sunt de acord cu acestea.<br><br>';
      for (let i = 0; i < this.travelers.length; i++) {
        let travelerIndex = i+1;
        this.termsMessage = this.termsMessage + '<b>Călător ' + travelerIndex + '</b> : <br>' + '<a id="link-conditii-' + travelerIndex + '" href="'+ this.travelers[i].selectedQuotation.terms +'" target="_blank" class="terms-link">Condițiile poliței de asigurare</a><br><br>';
      }
      this.$bvModal.msgBoxConfirm(this.htmlToVNode(this.termsMessage), {
        title: "CONDIȚII",
        okTitle: "Am ințeles",
        cancelTitle: "Renunț"
      })
          .then(value => {
            if (value === true) EventBus.$emit('next-step')
          })
          .catch(err => {
            // An error occurred
          })
      $('#link-conditii-1').focus();
    }
  }
}
</script>

<style>
 .modal-title {
   font-size: 24px;
 }
 .terms-link {
   color: #00a8c8;
 }

#quotations-table table {
    border-bottom: 2px solid #007fda !important;
}

#quotations-table table th {
    background-color: #007fda !important;
    color: #fff !important;
    font-weight: 500 !important;
    font-size: 18px !important;
    padding: 27px 0 !important;
    vertical-align: middle !important;
}

#quotations-table table td {
    border-top: 2px solid #fda111 !important;
    padding: 10px 0 !important;
    color: #01345B !important;
    vertical-align: middle !important;
}

#quotations-table table h4.price-wrap {
    font-weight: 500 !important;
}

#quotations-table table h4.price-wrap span {
    font-size: 24px !important;
}

#quotations-table table td > div {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
}

#quotations-table table .btn-quotation-add {
    width: 156px;
    height: 56px;
}

#quotations-table table .btn-quotation-add:hover {
    background-color: #a2dca1 !important;
}

#quotations-total {
    font-size: 14px !important;
    font-weight: 500 !important;
}

</style>
